import { useLayoutEffect, useRef } from 'react';

/**
 * Auto-grows a textarea to fit its content (no resize handle, no scrollbar).
 * Re-measures whenever `value` changes.
 */
export function useAutoGrow(value: string) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = '0px';
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  return ref;
}
